module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module_newcar",
    attrs: {
      "id": 'module_' + _vm.dataId,
      "data-positionindex": _vm.dataPositionindex,
      "data-id": _vm.dataId
    }
  }, [(_vm.isShow) ? _c(_vm.template, {
    tag: "div",
    attrs: {
      "carList": _vm.carList
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35d8df3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/newcar/components/Default.vue
// module id = 103
// module chunks = 2 3 4 5